var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"loading-icon",attrs:{"src":require("@/assets/loading.svg")}}),_c('p',[_vm._v("Laden...")])])
}]

export { render, staticRenderFns }